var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z9gpgzt8ea)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.136 46.03a.5.5 0 0 0 .645-.288l1.604-4.205a.5.5 0 1 0-.935-.356l-1.425 3.737-3.738-1.425a.5.5 0 0 0-.356.934l4.205 1.604zm8.5-37.75-.326-.38.326.38zM3.77 45.36c-5.538-12.368-2.6-27.399 8.193-36.702L11.31 7.9C.173 17.5-2.856 33.01 2.858 45.768l.912-.409zm8.192-36.702c13.164-11.339 33.03-9.86 44.38 3.304l.757-.653C45.39-2.273 24.892-3.799 11.31 7.9l.653.758zM62.162 19.644a.5.5 0 0 0-.651.275l-1.7 4.167a.5.5 0 0 0 .927.377l1.51-3.704 3.704 1.51a.5.5 0 0 0 .377-.926l-4.167-1.699zM53.364 56.71l-.326-.38v.001l.326.379zM61.513 20.3c5.15 12.242 2.128 26.905-8.475 36.03l.652.758c10.942-9.416 14.058-24.546 8.744-37.175l-.921.387zm-8.476 36.03c-13.163 11.339-33.03 9.87-44.379-3.304l-.758.653c11.71 13.593 32.208 15.108 45.79 3.409l-.653-.758z",
    fill: "#85C11F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.238 25.936c5.648 5.647 5.104 17.795 5.104 17.795s-12.147.543-17.795-5.104c-5.648-5.648-5.104-17.796-5.104-17.796s12.147-.543 17.795 5.105zM38.073 29.76c-4.432 4.434-4.006 13.97-4.006 13.97s9.537.427 13.97-4.006c4.432-4.433 4.006-13.97 4.006-13.97s-9.537-.426-13.97 4.007zM33.363 43.741v9.633",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.295 33.746c8.503 5.466 9.057 9.984 9.057 9.984",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.516 35.74c-6.755 2.695-9.174 7.98-9.174 7.98M15.6 59.64a28.136 28.136 0 0 1 17.752-6.265c6.372 0 12.254 2.11 16.975 5.669",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z9gpgzt8ea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h65v65H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.b8548dd5642c0e5bb2cdc62f6bb31fe3.svg";
export { ForwardRef as ReactComponent };